import Header from './Header'
const Thankyou = () => {
    return (
        <div className="best">
            <Header />
         <div className="mizuki1">
            {/* <!-- <span className="ipsum"><i className="fa-solid fa-left-long"></i></span> --> */}
            <h1>Contact Us</h1>
            <span className="ipsum1"><i className="fa-solid fa-xmark"></i></span>
        </div>
        <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li>
                    <li>Sign In</li>
                </ul>
            </div>
        </div>
        <div className="thankbox">
            <h2>Thank You</h2>
            <p>We have recived your message and will revert soon.</p>
            <button>Send another Message</button>
            <p className="thankpara"><a href="#">Back to home page</a></p>
        </div>
        
        </div>
    );
};
  
export default Thankyou;